import { render, staticRenderFns } from "./UpdatePrize.vue?vue&type=template&id=2f273c14&scoped=true"
import script from "./UpdatePrize.vue?vue&type=script&lang=js"
export * from "./UpdatePrize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f273c14",
  null
  
)

export default component.exports